import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleConfirm = () => {
    // Construct logout URL with post-logout redirect URI
    const redirectUri = encodeURIComponent(window.location.origin + '/');
    const logoutUrl = `${import.meta.env.VITE_AUTH_LOGOUT_URL}?post_logout_redirect_uri=${redirectUri}`;
    
    // Clear auth state and redirect
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    window.location.href = logoutUrl;
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign Out
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Are you sure you want to sign out?
          </p>
        </div>
        <div className="mt-8 space-y-6">
          <div className="flex justify-center space-x-4">
            <button
              onClick={handleConfirm}
              className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-tedy-red hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tedy-red"
            >
              Yes, Sign Out
            </button>
            <button
              onClick={handleCancel}
              className="group relative flex justify-center py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tedy-red"
            >
              No, Stay Signed In
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
